var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.345 9.25H6.759a.5.5 0 01-.353-.15L4.845 7.543a1 1 0 00-.707-.293H1.154A1 1 0 00.26 8.7l2.5 5a.994.994 0 00.894.553h5.88a.25.25 0 01.177.427l-3.865 3.862a1 1 0 00.706 1.708h3.586a1 1 0 00.707-.293l5.561-5.557a.5.5 0 01.353-.146h4.586a2.5 2.5 0 000-5z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.492 8.1a.5.5 0 00.353.146h4.6a.25.25 0 00.176-.427l-3.78-3.78a1 1 0 00-.707-.293H8.552a1 1 0 00-.707 1.707z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.0a356117.svg";
export { ForwardRef as ReactComponent };